var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fetch_data)?_c('div',{staticClass:"Static"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.fetch_data.body)}})]):_vm._e(),(_vm.not_found)?_c('div',[_c('NotFound')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }